<template>
    <div>
        <DataTable v-if="cardsDataGrouped.length > 0" :value="cardsDataGrouped"
                   rowGroupMode="subheader" groupRowsBy="groupHeader.name"
                   :loading="cards_data_loading" class="p-datatable-striped p-datatable-sm">
            <Column field="groupHeader.name" header="GroupHeader"></Column>
            <Column field="name" :header="$t('AppRealTimeReportCards.Estatística')">
                <template #body="slotProps">
                    <div style="padding-left: 20px">
                        {{ slotProps.data.name }}
                    </div>
                </template>
            </Column>
            <Column field="value" :header="$t('AppRealTimeReportCards.Valor')">
            </Column>
            <template #groupheader="slotProps">
                <span style="font-weight: bold">{{ slotProps.data.groupHeader.name }}</span>
            </template>
        </DataTable>
        <div v-else class="show-no-data">
            {{$t('AppRealTimeReportCards.Sem dados no período')}}
        </div>
    </div>
</template>

<script>
import getTimeFromSecondsDurationFormatMixin from "@/mixins/DateMixin";
import dateHourFormat from '@/mixins/DateMixin'
import {formatHours} from "@/utils/hourFormat";
import {MODE} from "@/utils/indicators";

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
    mixins: [getTimeFromSecondsDurationFormatMixin, dateHourFormat],
    data() {
        return {
            cardsDataGrouped: {},
        }
    },
    props: {
        cards_data: {
            type: Object,
            required: true
        },
        cards_data_loading: {
            type: Boolean,
            required: true
        },
        first_part: {
            type: Boolean,
            required: true
        },
        vehicle_amount: {
            type: Number
        },
        selected_dates: {
            type: Object
        }
    },
    components: {DataTable, Column},
    watch: {
        cards_data: function (val) {
            if (!val.total) {
                this.cardsDataGrouped = [];
                return;
            }

            let total = val.total;
            let producing = val.byMode[MODE.PRODUCING];
            let idle = val.byMode[MODE.IDLE];
            let maneuvering = val.byMode[MODE.MANEUVERING];
            let traveling = val.byMode[MODE.TRAVELING];

            if (this.first_part) {
                this.cardsDataGrouped = [
                    ...this.buildGroup('Total', [
                        ['Área', total.area, 'ha'],
                        ['Combustível Total', total.totalFuel, 'L'],
                        ['Tempo de Motor Ligado', total.engineOnTime, 'h'],
                        ['Distância', total.distance, 'km'],
                        ['Rendimento', total.fuelPerHectare, 'L/ha'],
                        ['Consumo médio', total.fuelRateByTime, 'L/h'],
                        ['Taxa de combustível (Área)', total.fuelRateByArea, 'km/L'],
                        ['Velocidade média', total.speed, 'km/h'],
                        ['Disponibilidade mecanica', total.mechanicalAvailability, '%'],
                        ['Eficiência', total.efficiency, '%'],
                        ['Produtividade', total.productivity, 'ha/h']
                    ]),
                    ...this.buildGroup('Trabalhando', [
                        ['Área', producing.area, 'ha'],
                        ['Combustível', producing.totalFuel, 'L'],
                        ['Tempo', producing.totalTime, 'h'],
                        ['Distância', producing.distance, 'km'],
                        ['Rendimento', producing.fuelPerHectare, 'L/ha'],
                        ['Consumo médio', producing.fuelRateByTime, 'L/h'],
                        ['Velocidade média', producing.speed, 'km/h'],
                        ['Produtividade', producing.productivity, 'ha/h']
                    ]),
                    ...this.buildGroup('Ocioso', [
                        ['Combustível', idle.totalFuel, 'L'],
                        ['Tempo', idle.totalTime, 'h'],
                        ['Consumo médio', idle.fuelRateByTime, 'L/h']
                    ])
                ];
                return;
            }

            this.cardsDataGrouped = [
                ...this.buildGroup('Manobrando', [
                    ['Combustível', maneuvering.totalFuel, 'L'],
                    ['Tempo', maneuvering.totalTime, 'h'],
                    ['Consumo médio', maneuvering.fuelRateByTime, 'L/h'],
                    ['Velocidade média', maneuvering.speed, 'km/h']
                ]),
                ...this.buildGroup('Deslocando', [
                    ['Combustível', traveling.totalFuel, 'L'],
                    ['Tempo', traveling.totalTime, 'h'],
                    ['Consumo médio', traveling.fuelRateByTime, 'L/h'],
                    ['Velocidade média', traveling.speed, 'km/h']
                ])
            ];
        }
    },
    methods: {
        buildGroup(groupKey, rows) {
            let groupHeader = {name: this.$t('AppRealTimeReportCards.' + groupKey)};
            return rows.map(([key, value, symbol]) => ({
                name: this.$t('AppRealTimeReportCards.' + key),
                value: this.formatValue(value, symbol),
                groupHeader
            }));
        },
        formatValue(value, symbol) {
            if (!value || !isFinite(value)) {
                return 'N/D';
            }

            if (symbol === 'h') {
                return formatHours(value);
            }

            return value.toFixed(2) + ' ' + symbol;
        }
    },
}
</script>

<style scoped>

.show-no-data {
    background-color: #323234;
    height: 100%;
    color: white;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
